import React, { useState } from "react";
import { useSelector } from "react-redux";
import { fetchMemory } from "./../redux/ducks/memory";
import useStatusThunk from "../hook/useStatusThunk";
import useEffectWithoutLoad from "../hook/useEffectWithoutLoad";
import useAuthEffect from "../hook/useAuthEffect";
import { Row, Table } from "../components/dumb/DataTable";
import { fetchTask } from "../redux/ducks/task";

const TaskMemoryRoute = ({ match }) => {

    const memoryID = match.params.memoryID;
    const taskID = match.params.taskID;
    const memory = useSelector(state => state.memory.memories[memoryID]);
    const task = useSelector(state => state.task.tasks[taskID]);
    const [dispatch_fetchMemory, status_fetchMemory, error_fetchMemory] = useStatusThunk(fetchMemory);
    const [dispatch_fetchTask, status_fetchTask, error_fetchTask] = useStatusThunk(fetchTask);
    const [rows, setRows] = useState([]);

    useAuthEffect(isAuth => {
        dispatch_fetchMemory({ memoryID });
        dispatch_fetchTask({ taskID });
    });

    useEffectWithoutLoad(() => {
        if (status_fetchMemory == "success" && status_fetchTask == "success") {
            setRows(memory.entries.map((entry, index) => {
                const target = entry.targets.find(target => target.lang == task.targetLang);
                return {
                    ID: entry.id,
                    index,
                    source: entry.source,
                    target: target?.text
                }
            }));
        }
    }, [status_fetchMemory, status_fetchTask, memory?.entries, task]);

    return (
        <div className="columns-container">
            <div className="column column--primary">
                <Entries rows={rows} memoryID={memoryID} sourceLang={task?.sourceLang} targetLang={task?.targetLang} />
            </div>
        </div >
    )
}

const Entries = props => {

    const renderRow = (row, renderData, extra) => <Row className={"entry-row " + (row.modified ? "entry-row--modified" : "")}>
        {renderData(row.ID, { key: "id" })}
        {renderData(row.source, { key: "source" })}
        {renderData(row.target ? row.target : "", { key: "target" })}
    </Row>

    let titleContent = <React.Fragment></React.Fragment>

    return (
        <Table title="entries" titleContent={titleContent} renderRow={renderRow} customRow={true}
            rows={props.rows} cols={[
                { name: "id", sortCol: "ID" },
                { name: props.sourceLang, sortCol: "source" },
                { name: props.targetLang, sortCol: "target" }
            ]} />
    )
}

export default TaskMemoryRoute;